// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class LocationValidAddressResponseModel {
    static getAttributeTypeMap() {
        return LocationValidAddressResponseModel.attributeTypeMap;
    }
}
LocationValidAddressResponseModel.discriminator = undefined;
LocationValidAddressResponseModel.attributeTypeMap = [
    {
        "name": "addresses",
        "baseName": "addresses",
        "type": "Array<LocationValidAddressModel>"
    },
    {
        "name": "hasMatches",
        "baseName": "hasMatches",
        "type": "boolean"
    },
    {
        "name": "hasMultipleMatches",
        "baseName": "hasMultipleMatches",
        "type": "boolean"
    }
];
//# sourceMappingURL=locationValidAddressResponseModel.js.map